//this used in following component:
/*
App.jsx
sidePanel.jsx
Activity.jsx
userActivity.jsx
*/


/*
line on which color changed to set to default
default.css
    13, 167, 176,185

default_theme.css 
    155
*/
import $ from 'jquery'
import { buttonFontColor } from '../config/constant'
//--------------------------------Menu Color set -----------------------------------

export const selectItemColor = (menuColor, id) => {
    console.log("menuColor", id);
    if (id === "logo") {
        $('.link-item').css('background', menuColor.backgroundColor);
    } else if (menuColor && menuColor.selectorColor) {
        $('.link-item').css('background', menuColor.backgroundColor);
        $(`#${id}`).css('background', menuColor.selectorColor);
    }
    if (menuColor && menuColor.assetFontColor) {
        $('.link-item').css('color', menuColor.assetFontColor);
        //$(`#${id}`).css('background', menuColor.selectorColor);
    }
}

//--------------------------- Home Color Set ----------------------------------------

export const hoverColor = (key, menuColor) => {
    $('.shortcutKeyHover').css('color', menuColor.assetFontColor);
    $(key).hover(
        function () {
            if (menuColor && menuColor.assetBackgroundColor) {
                $(key).css('background', menuColor.assetBackgroundColor);
            }
            if (menuColor && menuColor.assetFontColor) {
                $(key).css('color', menuColor.assetFontColor);
            }
            if (menuColor && menuColor.assetBackgroundSelectorColor) {
                $(this).css('background', menuColor.assetBackgroundSelectorColor);
            }
            if (menuColor && menuColor.assetFontSelectorColor) {
                $(this).css('color', menuColor.assetFontSelectorColor);
            }
        },
        function () {
            if (menuColor && menuColor.assetBackgroundColor) {
                $(key).css('background', menuColor.assetBackgroundColor);
            }
            if (menuColor && menuColor.assetFontColor) {
                $(key).css('color', menuColor.assetFontColor);
            }
        }
    )
    if (key === ".sch-link") {
        $(".timeInActvity").hover(
            function () {
                if (menuColor && menuColor.assetBackgroundSelectorColor) {
                    $(this).css('background', menuColor.assetBackgroundSelectorColor);
                }
                if (menuColor && menuColor.assetFontSelectorColor) {
                    $(this).css('color', menuColor.assetFontSelectorColor);
                }
            }, function () {
                if (menuColor && menuColor.assetBackgroundColor) {
                    $(".timeInActvity").css('background', menuColor.assetBackgroundColor);
                }
                if (menuColor && menuColor.assetFontColor) {
                    $(".timeInActvity").css('color', menuColor.assetFontColor);
                }
            }
        )
    }
}

export const setColor = (menuColor) => {
    //console.log("setColor called");
    if (menuColor && menuColor.backgroundColor) {
        $('#app-nav').css('background', menuColor.backgroundColor);
        $('.mast-head').css('background', menuColor.backgroundColor);
    }
    if (menuColor && menuColor.assetBackgroundColor) {
        $('.widget-contents').css('background', menuColor.assetBackgroundColor);
        $('.widget-contents').css('opacity', "0.9");
    }
    if (menuColor && menuColor.assetFontColor) {

        $('.greet').css('color', menuColor.assetFontColor);
        $('.date').css('color', menuColor.assetFontColor);
        $('.time').css('color', menuColor.assetFontColor);
        $('.weather').css('color', menuColor.assetFontColor);
        $('.widget-heading').css('color', menuColor.assetFontColor);
        $('.schedules').css('color', menuColor.assetFontColor);
        $('.shortcuts').css('color', menuColor.assetFontColor);
        //$('.view-all').css('color', menuColor.assetFontColor);
        //$('body').css('color', menuColor.assetFontColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.view-all').css('background', menuColor.assetBackgroundSelectorColor);
        //if(menuColor && menuColor.assetFontSelectorColor)
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        // $('.view-all').css('color', menuColor.assetFontSelectorColor);
        //if(menuColor && menuColor.assetFontSelectorColor)
    }
}
//-------------------------------------Activity Clor Set ---------------------------

export const setActivityColor = (menuColor) => {
    if (menuColor && menuColor.assetBackgroundColor) {
        $('#activity-list').css('background', menuColor.assetBackgroundColor);
        $('#activity-list-results').css('background', menuColor.assetBackgroundColor);
        $('.activity-option-items').css('background', menuColor.assetBackgroundColor);
    }
    if (menuColor && menuColor.assetFontColor) {
        $('.activity-heading').css('color', menuColor.assetFontColor);
        $('.activity-item').css('color', menuColor.assetFontColor);
        $('.option-item-desc').css('color', menuColor.assetFontColor);
        $('.activity-option-choices').css('color', menuColor.assetFontColor);
    }
}

export const ActvitySelectedColor = (id, menuColor) => {
    console.log("id", id)
    if (id && menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.activity-item').css('background', menuColor.assetBackgroundColor);
        $(`#${id}`).css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (id && menuColor && menuColor.assetFontSelectorColor) {
        $('.activity-item').css('color', menuColor.assetFontColor);
        $(`#${id}`).css('color', menuColor.assetFontSelectorColor);
    }

}

//-----------------------------------------------Music Color set-----------------------------------

export const musicPlayListColor = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        //$('.playlist-name').css('color', menuColor.assetFontColor);
    }
}

export const musicSongListColor = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        $('#loadList').css('color', menuColor.assetFontColor);
        //$('.search-back').css('color', menuColor.assetFontColor);
        //$('.nav-vertical').css('color', menuColor.assetFontColor);
    }
    // if (menuColor && menuColor.assetFontSelectorColor) {
    // }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.search-back').css('background', menuColor.assetBackgroundSelectorColor);
        $('.nav-vertical').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        // $('.search-back').css('color', menuColor.assetFontSelectorColor);
        //if(menuColor && menuColor.assetFontSelectorColor)
    }
}

//-----------------------------------------------VOD Color set-----------------------------------

export const VODPlayListColor = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        $('#movie-widgets').css('color', menuColor.assetFontColor);
    }
}

export const VODSearchColor = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        //$('.search-back').css('color', menuColor.assetFontColor);
        $('.listen-search-box').css('color', menuColor.assetFontColor);
        $('.title').css('color', menuColor.assetFontColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.search-back').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        //  $('.search-back').css('color', menuColor.assetFontSelectorColor);
    }
}

export const VODMovieInfoColor = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        //$('.search-back').css('color', menuColor.assetFontColor);
        $('.movie-item-box').css('color', menuColor.assetFontColor);
    }
    if (menuColor && menuColor.assetBackgroundColor) {
        $('.movie-item-box').css('background', menuColor.assetBackgroundColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.play-movie').css('background', menuColor.assetBackgroundSelectorColor);
        $('.preview-movie').css('background', menuColor.assetBackgroundSelectorColor);
        $('.search-back').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        //$('.search-back').css('color', menuColor.assetFontSelectorColor);
        $('.movie-controls').css('color', menuColor.assetFontSelectorColor);
    }
}

//-------------------------Movie (Video player) color set---------------------------------

export const MovieSearchColor = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        $('.listen-search-box').css('color', menuColor.assetFontColor);
        $('.title').css('color', menuColor.assetFontColor);
        $('.activity-item-name').css('color', menuColor.assetFontColor);
    }
}

//----------------------popup color set------------------------------

export const popupColorSet = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        //$('.search-back').css('color', menuColor.assetFontColor);
        $('.overlay-body').css('color', menuColor.assetFontColor);
    }
    if (menuColor && menuColor.assetBackgroundColor) {
        $('.overlay-body').css('background', menuColor.assetBackgroundColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.overlay-close').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        //$('.overlay-close').css('color', menuColor.assetFontSelectorColor);
    }
}

//--------------------device registration color set-----------------------------------------

export const deviceRegColorset = (menuColor) => {
    //$('.col').css('color', "red");
    if (menuColor && menuColor.assetFontColor) {
        //$('.search-back').css('color', menuColor.assetFontColor);
        $('#devReg').css('color', menuColor.assetFontColor);
        $('#connectorReg').css('color', menuColor.assetFontColor);
        $('.form-controls').css('color', menuColor.assetFontColor);
        $('#roomSelect').css('color', menuColor.assetFontColor);
    }
    if (menuColor && menuColor.assetBackgroundColor) {
        $('#devReg').css('background', menuColor.assetBackgroundColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.secondary').css('background', menuColor.assetBackgroundSelectorColor);
        $('.primary').css('background', menuColor.assetBackgroundSelectorColor);
        $('.scroll-nav').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        $('.secondary').css('color', "#fff"/*menuColor.assetFontSelectorColor*/);
        $('.primary').css('color', "#fff"/*menuColor.assetFontSelectorColor*/);
        $('.scroll-nav').css('color', menuColor.assetFontSelectorColor);
    }
}

export const conformationColorSet = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        //$('.search-back').css('color', menuColor.assetFontColor);
        $('.overlay-body').css('color', menuColor.assetFontColor);
    }
    if (menuColor && menuColor.assetBackgroundColor) {
        $('.overlay-body').css('background', menuColor.assetBackgroundColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.btn-yes').css('background', menuColor.assetBackgroundSelectorColor);
        $('.btn-no').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        $('.btn-yes').css('color', menuColor.assetFontSelectorColor);
        $('.btn-no').css('color', menuColor.assetFontSelectorColor);
    }
}

//--------------------guest registration color set-----------------------------------------

export const guestDdeviceRegColorset = (menuColor) => {
    //$('.col').css('color', "red");
    if (menuColor && menuColor.assetFontColor) {
        //$('.search-back').css('color', menuColor.assetFontColor);
        $('#guestDevReg').css('color', menuColor.assetFontColor);
        $('#connectorReg').css('color', menuColor.assetFontColor);
        $('.form-controls').css('color', menuColor.assetFontColor);
        $('#roomSelect').css('color', menuColor.assetFontColor);
    }
    if (menuColor && menuColor.assetBackgroundColor) {
        $('#guestDevReg').css('background', menuColor.assetBackgroundColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.secondary').css('background', menuColor.assetBackgroundSelectorColor);
        $('.primary').css('background', menuColor.assetBackgroundSelectorColor);
        $('.scroll-nav').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        $('.secondary').css('color', "#fff"/*menuColor.assetFontSelectorColor*/);
        $('.primary').css('color', "#fff"/*menuColor.assetFontSelectorColor*/);
        $('.scroll-nav').css('color', menuColor.assetFontSelectorColor);
    }
}
//-------------------------room Control---------------------------

export const roomControl = (menuColor, index) => {
    // if (menuColor && menuColor.assetBackgroundColor) {
    //     $('.activity-heading').css('background', menuColor.assetBackgroundColor);
    // }
    if (menuColor && menuColor.assetBackgroundColor) {
        $('.activity-item').css('background', "none");
    }
    if (menuColor && menuColor.assetFontColor) {
        $('.search-back').css('color', menuColor.assetFontColor);

        $('.activity-item').css('color', menuColor.assetFontColor);
        $('.activity-heading').css('color', menuColor.assetFontColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $(`#control${index}`).css('background', menuColor.assetBackgroundSelectorColor);
        $('.button').css('background', menuColor.assetBackgroundSelectorColor);
        $('.return-button').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontSelectorColor) {
        $(`#control${index}`).css('color', menuColor.assetFontSelectorColor);
    }
}

export const buttonColor = (menuColor) => {
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.button').css('background', menuColor.assetBackgroundSelectorColor);
        $('.getColor').css('background', menuColor.assetBackgroundSelectorColor);
        //$('#ac-power-switch').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontColor) {
        $(`#controls-ac`).css('color', menuColor.assetFontColor);
        $(`#temp-selection`).css('color', menuColor.assetFontColor);
        $('#controls-light').css('color', menuColor.assetFontColor);
        $('#controls-curtain').css('color', menuColor.assetFontColor);
        $('#controls-door').css('color', menuColor.assetFontColor);
        $('#controls-speaker').css('color', menuColor.assetFontColor);
    }
    $('.button').css('color', "#ffffff");
}

export const onControlClick = (id, mode, menuColor) => {
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.return-button').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (mode === "tempControl") {
        $('#cooler').css('color', "#ffffff");
        $('#warmer').css('color', "#ffffff");
        if (id && menuColor && menuColor.assetFontSelectorColor) {
            $(`#${id}`).css('color', menuColor.assetFontSelectorColor);
        }
    } else if (mode === "mode") {
        $('#fanOnly').css('color', "#ffffff");
        $('#fanFixed').css('color', "#ffffff");
        $('#fanAuto').css('color', "#ffffff");
        $('#fanOff').css('color', "#ffffff");
        if (id && menuColor && menuColor.assetFontSelectorColor) {
            $(`#${id}`).css('color', menuColor.assetFontSelectorColor);
        }
    } else if (mode === "fanSpeed") {
        $('#FAN_SPEED_AUTO').css('color', menuColor.assetFontColor);
        $('#FAN_SPEED_LOW').css('color', menuColor.assetFontColor);
        $('#FAN_SPEED_MED').css('color', menuColor.assetFontColor);
        $('#FAN_SPEED_HIGH').css('color', menuColor.assetFontColor);
        if (id && menuColor && menuColor.assetFontSelectorColor) {
            $(`#${id}`).css('color', menuColor.assetFontSelectorColor);
        }
    } else if (mode === "unit") {
        $('#unitFarenheit').css('color', "#ffffff");
        $('#unitCelsius').css('color', "#ffffff");
        if (id && menuColor && menuColor.assetFontSelectorColor) {
            $(`#${id}`).css('color', menuColor.assetFontSelectorColor);
        }
    } else if (mode === "door") {
        $('#openDoorCamera').css('color', "#ffffff");
        $('#unlockFrontDoor').css('color', "#ffffff");
        if (id && menuColor && menuColor.assetFontSelectorColor) {
            $(`#${id}`).css('color', menuColor.assetFontSelectorColor);
        }
    } else if (mode === "lightMood") {
        // $('.button').css('color', "#ffffff");
        // $('.selected').css('color', menuColor.assetFontSelectorColor);
    } else if (mode === "speaker") {
        if (id === "BLUETOOTH" || id === "TV") {
            $('#BLUETOOTHSpeaker').css('color', "#ffffff");
            $('#TVSpeaker').css('color', "#ffffff");
        }
        if (id === "speakerVolUp" || id === "speakerVoldown") {
            $('#speakerVolUp').css('color', "#ffffff");
            $('#speakerVoldown').css('color', "#ffffff");
        }
        if (id && menuColor && menuColor.assetFontSelectorColor) {
            $(`#${id}Speaker`).css('color', menuColor.assetFontSelectorColor);
        }
    } else if (mode === "curtains") {
        $('#curtain1ON').css('color', "#ffffff");
        $('#curtain1OFF').css('color', "#ffffff");
        $('#curtain2ON').css('color', "#ffffff");
        $('#curtain2OFF').css('color', "#ffffff");
        if (id && menuColor && menuColor.assetFontSelectorColor) {
            $(`#${id}`).css('color', menuColor.assetFontSelectorColor);
        }
    }
}

export const listOnSelect = (menuColor) => {
    $('.button').css('color', "#ffffff");
    if (menuColor && menuColor.assetFontSelectorColor) {
        $('.selected').css('color', menuColor.assetFontSelectorColor);
        $('.selected').css('border-color', menuColor.assetFontSelectorColor);
    }
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.button').css('background', menuColor.assetBackgroundSelectorColor);
        $('.return-button').css('background', menuColor.assetBackgroundSelectorColor);
    }
    //$('.selected').css('background', "#666666");
    $('.selected').css('background', menuColor.backgroundColor);
}
//---------------------------TV Control color-----------------------------------

export const setTVControlColor = (menuColor) => {
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.button').css('background', menuColor.assetBackgroundSelectorColor);
    }
    if (menuColor && menuColor.assetFontColor) {
        //$('.search-back').css('color', menuColor.assetFontColor);
        $('.my-label').css('color', menuColor.assetFontColor);
        $('.ch-list-title').css('color', menuColor.assetFontColor);
        $('.nav-right').css('color', menuColor.assetFontColor);
        $('.nav-left').css('color', menuColor.assetFontColor);
    }
    $('.selected').css('background', menuColor.backgroundColor);
    $('.selected').css('color', menuColor.assetFontSelectorColor);
    $('.selected').css('border-color', menuColor.assetFontSelectorColor);
}

//===================================h-commerce==================================

export const setAddOnItems = () => {
    console.log("Add item called")
    $('#rsAddOnItem').removeClass('open-item');
}

export const hCommColors = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        //$('.search-back').css('color', menuColor.assetFontColor);
        $('#ico-room-svc').css('color', menuColor.assetFontColor);
    }
    $('.search-back').css('color', '#fff');
}

export const hCommButtonColor = (menuColor) => {
    // if (menuColor && menuColor.assetFontColor) {
    //     //$('.search-back').css('color', menuColor.assetFontColor);
    //     $('#ico-room-svc').css('color', menuColor.assetFontColor);
    // }
    $('.search-back').css('color', buttonFontColor);
    $('.button').css('color', buttonFontColor);
    $('#my-orders').css('color', buttonFontColor);
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('.search-back').css('background', menuColor.assetBackgroundSelectorColor);
        $('.button').css('background', menuColor.assetBackgroundSelectorColor);
    }
}

//================================Guest request widget ================================

export const guestRequestColor = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        $('#ico-guest-services').css('color', menuColor.assetFontColor);
    }
}

export const guestRequestButton = (menuColor) => {

    $('.button').css('color', "#fff");
    if (menuColor && menuColor.assetBackgroundSelectorColor) {

        $('#GuestRequestSubmit').css('background', menuColor.assetBackgroundSelectorColor);
        $('#GuestRequestSubmitForm').css('background', menuColor.assetBackgroundSelectorColor);
    }
}

export const viewBIllColorConfig = (menuColor) => {
    if (menuColor && menuColor.assetFontColor) {
        $('#ico-view-bill').css('color', menuColor.assetFontColor);
        $('#vb-list').css('color', menuColor.assetFontColor);
    }
    $('#viewBillButton').css('color', buttonFontColor);
    $('#viewBillExpressCheckOut').css('color', buttonFontColor);
    $('#viewBillExtendStay').css('color', buttonFontColor);
    if (menuColor && menuColor.assetBackgroundSelectorColor) {
        $('#viewBillButton').css('background', menuColor.assetBackgroundSelectorColor);
        $('#viewBillExpressCheckOut').css('background', menuColor.assetBackgroundSelectorColor);
        $('#viewBillExtendStay').css('background', menuColor.assetBackgroundSelectorColor);
        //$('#GuestRequestSubmitForm').css('background', menuColor.assetBackgroundSelectorColor);
    }
}

export const cmsColorConfig = (menuColor) => {
    console.log("cmsColorConfig");
    $('.button').css('background', menuColor.assetBackgroundSelectorColor);
    $('.button').css('color', "#fff");
    //$('.selected').css('color', menuColor.assetFontSelectorColor);
    if (menuColor && menuColor.assetFontColor) {
        $('.rc-controls').css('color', menuColor.assetFontColor);
    }
}